import { MutationTree } from "vuex";
import { AppState } from "./app.module";
import { MUTATIONS } from "@/constants/mutations";
import { ToastModel } from "@/interfaces/app/toast-model";

export const APP_MUTATIONS: MutationTree<AppState> = {
  [MUTATIONS.app.updateToastModal](state, toast: ToastModel): void {
    state.toastModal = { ...toast, status: true };
  },

  [MUTATIONS.app.dismissToast](state): void {
    state.toastModal = { ...state.toastModal, status: false };
  },

  [MUTATIONS.app.toggleSidebarStatus](state): void {
    state.sidebarStatus = !state.sidebarStatus;
  }
};
